import React from 'react';
import { useTranslation } from 'react-i18next';

const FinalSlide: React.FC = () => {
  const { t } = useTranslation();
  const trustItems = t('demoTour.final.trustItems', { returnObjects: true }) as string[];

  return (
    <div className="dt-final">
      <div className="dt-final-icon">{t('demoTour.final.icon')}</div>
      <h2 className="dt-final-title">{t('demoTour.final.title')}</h2>
      <p className="dt-final-description">{t('demoTour.final.description')}</p>
      <a href="/register" className="dt-final-cta">
        {t('demoTour.final.cta')}
      </a>
      <div className="dt-final-trust">
        {trustItems.map((item) => (
          <span key={item} className="dt-final-trust-item">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};

export default FinalSlide;
